import { P2GGrid, P2GText } from '@parcel2go/core-ui';
import { Trans, useTranslation } from 'react-i18next';
import { TranslationNamespaces } from '~/lib/constants';
import { Restrictions } from '~/lib/types/basket-types';

export const DimensionsWarning = ({ restrictions }: { restrictions: Restrictions }) => {
  const { t } = useTranslation([TranslationNamespaces.CHECKOUT]);
  if (!restrictions.maxHeight || !restrictions.maxWidth || !restrictions.maxLength) return null;

  return (
    <P2GGrid item>
      <P2GText dataTestId="parcel-max-dimensions">
        <Trans
          i18nKey="DIMENSION_WARNING_RESTRICTIONS_REQUIRED"
          t={t}
          defaults="Dimensions are required for this service: Max <0>{{maxHeight}}</0>x<1>{{maxWidth}}</1>x<2>{{maxLength}}</2>cm."
          values={{
            maxHeight: restrictions.maxHeight,
            maxWidth: restrictions.maxWidth,
            maxLength: restrictions.maxLength
          }}
          components={[
            <P2GText dataTestId="parcel-max-dimensions-height" />,
            <P2GText dataTestId="parcel-max-dimensions-width" />,
            <P2GText dataTestId="parcel-max-dimensions-length" />
          ]}
        />
      </P2GText>
    </P2GGrid>
  );
};
